import { computed } from "vue";
const useStringValueProps = {
  separator: { type: String, default: ", " }
};
const useStringValue = (props, visibleSelectedOptions, getText) => {
  return computed(() => {
    var _a;
    if (!((_a = visibleSelectedOptions.value) == null ? void 0 : _a.length)) {
      return props.clearValue;
    }
    return visibleSelectedOptions.value.map(getText).join(props.separator) || props.clearValue;
  });
};
export {
  useStringValue as a,
  useStringValueProps as u
};
//# sourceMappingURL=useStringValue-1b278456.mjs.map
